export class Vorversicherung {
  antragsart = "";
  gesellschaft = "";
  versicherungsscheinnummer = "";
  vertragEnde = "";
  gekuendigtVon = "";

  //Frontend-spezifische Erweiterung
  vorhanden: boolean | null;

  constructor() {
    this.vorhanden = null;
  }
}
